<div class="flex-row flex-wrap footer-top">
  <div>
    <img src="assets/hhs-logo.png" alt="HHS" />
  </div>
  <div>
    <mat-label class="section-label">HHS Headquarters</mat-label>
    <address>
      <strong>U.S. Department of Health &amp; Human Services</strong><br />
      200 Independence Avenue, S.W.<br />
      Washington, D.C. 20201<br />
      Toll Free Call Center: 1-877-696-6775
    </address>
  </div>
</div>

<div class="flex-row flex-wrap link-list">
  <div class="flex-column flex-wrap">
    <ul>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/about/contact-us/index.html"
          >Contact HHS</a
        >
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/answers/index.html"
          >HHS FAQs</a
        >
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/civil-rights/for-individuals/nondiscrimination/index.html"
          >Nondiscriminatory Notice</a
        >
      </li>
    </ul>
  </div>
  <div>
    <ul>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/web/section-508/index.html"
          >Accessibility</a
        >
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/web/policies-and-standards/hhs-web-policies/privacy/index.html"
          >Privacy Policy</a
        >
      </li>
    </ul>
  </div>
  <div class="flex-column flex-wrap">
    <ul>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/about/budget/fy2024/index.html"
          >Budget/Performance</a
        >
      </li>
      <li>
        <a target="_blank" rel="noopener noreferrer" href="https://oig.hhs.gov/"
          >Inspector General</a
        >
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/about/agencies/asa/eeo/no-fear-act/index.html"
          >EEO/No Fear Act</a
        >
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html"
          >Vulnerability Disclosure Policy</a
        >
      </li>
    </ul>
  </div>
  <div>
    <ul>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hhs.gov/foia/index.html"
          >FOIA</a
        >
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.whitehouse.gov/"
          >The White House</a
        >
      </li>
      <li>
        <a target="_blank" rel="noopener noreferrer" href="https://www.usa.gov/"
          >USA.gov</a
        >
      </li>
    </ul>
  </div>
</div>

<div class="go-to-top">
  <a href="#" (click)="scrollTop($event)">Return to top</a>
</div>

<div class="version">
  <p>v{{ appVersion }}</p>
</div>
